import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useToast } from 'context/providers/ToastProvider';
import CardsEmpleados from './CardsEmpleados';
import SkeletonListaEmpleados from './SkeletonListaEmpleados';
import FiltrosEmpleados from './FiltrosEmpleados'
import FooterPaginacion from './FooterPaginacion'

const Empleados = () => {
    const { token, setToken, idCatTipoUsuario } = useToken();
    const navigate = useNavigate();
    const { showErrorToast } = useToast();
    const { idUsuario } = useParams();

    const [filtroCategoria, setFiltroCategoria] = useState(null);
    const [filtroEstatus, setFiltroEstatus] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [empleados, setEmpleados] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [searchFilter, setSearchFilter] = useState('');
    const mostrarEmpleados = async (page = 1, currentSize = pageSize) => {
        setCargando(true);
        const filtrosConPaginacion = {
            categoria: filtroCategoria,
            estatus: filtroEstatus,
            search: searchFilter || null,
            pageNumber: page,
            pageSize: currentSize
        };

        console.log('🔍 Filtros enviados:', filtrosConPaginacion); // ← Debug

        try {
            const response = await fetch("/api/usuario/ObtenerEmpleados", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(filtrosConPaginacion)
            });

            if (response.ok) {
                const data = await response.json();
                console.log('📦 Respuesta del backend:', data); // ← Debug

                if (data.iResponseType == 1) {
                    const ObjDetalles = JSON.parse(data.detalles);
                    console.log('📊 Detalles parseados:', ObjDetalles); // ← Debug
                    console.log('📋 Table2 (empleados):', ObjDetalles.table2); // ← Debug
                    console.log('🔢 Table3 (totalRecords):', ObjDetalles.table3); // ← Debug

                    setEmpleados(ObjDetalles.table2 || []);
                    const total = ObjDetalles.table3?.[0]?.totalRecords || 0;
                    console.log('✅ Total Records:', total); // ← Debug
                    setTotalRecords(total);
                } else {
                    showErrorToast(data.vMessage);
                }
            } else if (response.status == 401) {
                setToken(null);
                navigate("/");
            }
        } catch (error) {
            console.error('❌ Error:', error); // ← Debug
            showErrorToast('Error: ' + error.message);
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        if (idCatTipoUsuario != 1) {
            navigate("/");
            return;
        }
        setPageNumber(1);
        mostrarEmpleados(1, pageSize);
    }, [filtroCategoria, filtroEstatus, pageSize, searchFilter]);

    useEffect(() => {
        if (idCatTipoUsuario != 1)
            return;
            mostrarEmpleados(pageNumber, pageSize);       
    }, [pageNumber]);


    // Handler para convertir el valor del select de categoría a número/null
    const handleCategoriaChange = (e) => {
        const value = e.target.value;
        if (value === 'todos') {
            setFiltroCategoria(null);
        } else {
            setFiltroCategoria(parseInt(value)); // Convertir string a número
        }
    };

    // Handler para convertir el valor del select de estatus a booleano/null
    const handleEstatusChange = (e) => {
        const value = e.target.value;
        if (value === 'todos') {
            setFiltroEstatus(null);
        } else if (value === 'true') {
            setFiltroEstatus(true);
        } else if (value === 'false') {
            setFiltroEstatus(false);
        }
    };

    return (
        <>
            {/* Header Card */}
            <Card className="mb-1 p-2">
                <Row className="g-2 align-items-sm-center">
                    <Col xs="auto">
                        <img src="/img/vendedor35.png" alt="icon" height={30} />
                    </Col>
                    <Col>
                        <h5 className="mb-0 text-900">Empleados / Usuarios del sistema</h5>
                    </Col>
                    {!idUsuario && (
                        <Col sm="auto" className="ms-auto">
                            <Link to="/contabilidad/empleados/nuevo" state={{ modoEdicionInicial: true }}>
                                <Button size="sm" variant="falcon-primary">Nuevo Usuario</Button>
                            </Link>
                        </Col>
                    )}
                </Row>
            </Card>

            {/* Filters & Content Card */}
            <Card className="mb-3">
                <Card.Header className="bg-light">
                    <Row className="gx-3 gy-2 align-items-end">
                        <FiltrosEmpleados
                            filtroCategoria={filtroCategoria}
                            filtroEstatus={filtroEstatus}
                            searchFilter={searchFilter}
                            onCategoriaChange={handleCategoriaChange}
                            onEstatusChange={handleEstatusChange}
                            onSearchChange={setSearchFilter}
                        />
                    </Row>
                </Card.Header>

                <Card.Body className="p-3">
                    <div className="mb-3">
                        <span className="fs--2 text-600 fw-semi-bold">
                            {totalRecords === 0 ? (
                                <span>No se encontraron empleados{searchFilter && ` para "${searchFilter}"`}</span>
                            ) : (
                                <span>
                                    Mostrando {((pageNumber - 1) * pageSize) + 1} a {Math.min(pageNumber * pageSize, totalRecords)} de {totalRecords} empleados
                                        {searchFilter && <span className="text-primary fw-semi-bold"> (Resultados encontrados por: "{searchFilter}")</span>}
                                </span>
                            )}
                        </span>
                    </div>

                    {cargando ? (
                        <SkeletonListaEmpleados columnNames={['Cargando...']} rows={pageSize} />
                    ) : (
                        <Row className="g-3">
                                <CardsEmpleados empleados={empleados} />
                        </Row>
                    )}
                </Card.Body>

                <Card.Footer className="bg-light border-top d-flex justify-content-between align-items-center py-2">
                    <FooterPaginacion
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        pageNumber={pageNumber}
                        onPageSizeChange={({ target }) => setPageSize(Number(target.value))}
                        onNextPage={() => setPageNumber(pageNumber + 1)}
                        onPreviousPage={() => setPageNumber(pageNumber - 1)}
                        onGotoPage={(val) => setPageNumber(val + 1)}
                    />
                </Card.Footer>
            </Card>
        </>
    );
};

export default Empleados;